import {
    BlogPostState,
    BlogPostsState,
    initialBlogPostState,
    initialBlogPostsState,
} from "@/mk2/apps/blogs/components/BlogPost/BlogPost.reducers";
import { AppState } from "@/mk2/reducers";

export const getBlogPostsState = (state: AppState): BlogPostsState =>
    state.containers.blogs.shared.blogPosts || initialBlogPostsState;

export const getBlogPostState = (state: AppState, postId: number): BlogPostState => {
    const blogPostsState = getBlogPostsState(state);
    return blogPostsState[postId] || initialBlogPostState;
};
